import { useCallback } from 'react'
import { Small } from 'syf-component-library/ui/typography'
import { CSRAlertBannerType, CustomBrandComponents } from 'typings/brands'
import { Body } from 'ui/molecules/AuthenticationSection/subcomponents'
import styled from 'styled-components'
import mediaQueries from 'mediaQueries'
import { translations } from '../brandTranslations'
import customerSupport from '../customerSupport'

const PhoneNumber = styled.span`
  display: inline-block;
  padding-left: 0.25em;

  @media screen and (${mediaQueries.greaterThanTiny}) {
    display: block;
    padding-left: 0;
  }
`

const CsrAlertContent: CustomBrandComponents['CsrAlertContent'] = ({
  i18n,
  type
}) => {
  const translate = useCallback(
    (key: string) => i18n({ csrNumber: key }, {}, translations),
    [i18n]
  )

  return (
    <>
      {type === CSRAlertBannerType.ONLINEACCESS && (
        <Small isInline>
          {translate('Please call Credit Services')}{' '}
          {customerSupport.contactUsBrc}
        </Small>
      )}
      {type === CSRAlertBannerType.ACCOUNTLOCK && (
        <Small isInline>
          {customerSupport.contactUsBrc} {translate('We will assist you')}
        </Small>
      )}
      {type === CSRAlertBannerType.INVALIDACCOUNT && (
        <Body isInline>{customerSupport.contactUsBrc}</Body>
      )}
      {(type === CSRAlertBannerType.REGISTRATIONINFO ||
        type === CSRAlertBannerType.REGISTRATIONACCOUNTLOCK) && (
        <Body
          isInline
          isSmall={type === CSRAlertBannerType.REGISTRATIONACCOUNTLOCK}
        >
          {i18n({ authenticationSection: 'contact' })}
          <PhoneNumber>{customerSupport.contactUsBrc}</PhoneNumber>
        </Body>
      )}
    </>
  )
}

export default CsrAlertContent
